import p from './patient.vue';

export default p;
